// extracted by mini-css-extract-plugin
module.exports = {"SearchResultsGrid":"styles_SearchResultsGrid__jk0CS","grid":"styles_grid__UGhrI","gridTop":"styles_gridTop__Y2Tcg","item":"styles_item__OZrda"};